import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { white } from 'constants/colors';

export const useStyles = makeStyles()((theme: Theme) => {
  return {
    slider: {
      '& .slick-track': {
        marginLeft: 0,
        marginRight: 0,
      },
      '& .slick-list': {
        // height: 470,

        '& .NFTCard-Root': {
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },

      '& .slick-dots': {
        whiteSpace: 'nowrap',
        
        '& li': {
          margin: 0,
          marginRight: 16,
          height: 3,
          width: 20,

          '&:last-of-type': {
            marginRight: 0,
          },

          '& button': {
            height: 3,
            width: 20,
            padding: 0,
            position: 'relative',

            '&:before': {
              background: '#3889FA',
              borderRadius: 3,
              height: 3,
              width: 20,
              fontSize: 0,
              position: 'absolute',
              top: '50%',
              left: 0,
            },
          },
        },
      },
      '& .slick-prev, & .slick-next': {
        width: 50,
        height: 50,
      },
      '& button': {
        '&:hover': {
          // backgroundColor: royalBlue,
          '& svg': {
            color: white,
          },
        },
      },
      [theme.breakpoints.up('sm')]: {
        '& .slick-slide>div': {
          padding: '0 8px',
        },
        '& .slick-list': {
          margin: '0 -8px',
        },
      },
    },
    arrowBtn: {
      position: 'absolute',
      top: '50%',
      zIndex: 99,
      boxShadow: 'none',

      '&:before': {
        display: 'none',
      },
      '&.slick-disabled': {
        display: 'none',
      },
    },
    left: {
      left: -16,
      [theme.breakpoints.up('lg')]: {
        left: -80,
      },
    },
    right: {
      right: -16,
      [theme.breakpoints.up('lg')]: {
        right: -80,
      },
    },
  };
});
